import config from '@/config'
import axios from 'axios'

const instance = axios.create({
  baseURL: `${config.getConfig('serverUrl')}nestle`,
  timeout: 30000,
  headers: {
    AUTHORIZATION: 'Bearer xxx xxx'
  }
})

export const bundleApi = {
  getAllBundles: (request) => {
    // {
    //     "search": "name bundle",
    //     "startDate": "YYYY-MM-DD", // optional
    //     "endDate": "YYYY-MM-DD", // optional
    //     "sortBy": "Promotion date", // optional
    //     "limit": 10,
    //     "offset": 0
    // }
    const { data } = request
    const { pageid, ...rest } = data
    return instance.get(`/${pageid}/webview/product-bundle/all-bundles`, rest)
  },
  calculateBundle: (request) => {
    const { data } = request
    const { pageid, userid, ...rest } = data
    return instance.get(
      `/webview/product-bundle/calculate-discount-bundle?pageId=${pageid}&userId=${userid}`,
      rest
    )
  }
}
